var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('structure-list',{ref:"invite_modal",attrs:{"id":"invite_modal","bauhof-structure":_vm.possibleInvites,"multi-select":false},on:{"on-selected":_vm.onInvite,"hidden":_vm.hidden}})}
var staticRenderFns = []

export { render, staticRenderFns }